export * from './reset-password.component';

